<template>
  <div class="card card--white small-top" :class="{'offering-info': !showAll}">
   <h1 v-if="showAll" class="clickable" @click="showAll = !showAll">
      {{offering.title}} <h-icon>keyboard_arrow_up</h-icon>
  </h1>
   <div class="card--container">
     <div class="overview" v-if="!showAll">
      <h2 class="clickable align-center" @click="showAll=true">
        {{offering.title}} 
        <h-icon>keyboard_arrow_right</h-icon>
     </h2>
     <div>
       Link: <a :href="offering.link" target="_blank">{{offering.link}}</a>
     </div>
    </div>
    <div v-if="showAll">
      <offering-card :habitPrograms="habitPrograms"
                   :pulseSurveys="pulseSurveys"
                   :company="company"
                   :coaches="coaches"
                   :courses="courses"
                   :offering="offering"
                   :subDomains="subDomains"
                   />
    </div>
  </div>
    
  </div>
</template>

<script>
import offeringCard from "./offeringsCard";

export default {
  components: { offeringCard },
  props: ["offering", "pulseSurveys", "habitPrograms", "company", "coaches", "courses", "subDomains"],
  data() {
    return {
      showAll: false
    }
  }

}
</script>

<style lang="less" scoped>
h1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  i {
    color: white;
  }
}
.offering-info {
  min-height: 100px;
  .overview {
    color: black !important;

    h2 {
      color: black;
    }
    i {
      color: black
    }
  }


}

</style>
